import React, { useEffect } from 'react';
import { initMetaPixel, META_PIXEL_ID } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { MainProduct } from './components/MainProduct';
import { Bonuses } from './components/Bonuses';
import { Collection } from './components/Collection';
import { GrowthMessage } from './components/GrowthMessage';
import { OfferStack } from './components/OfferStack';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="28suveqfd63nb">
      <noscript data-id="element-1" data-mp="23vuq4hqc94x9">
        <img height="1" width="1" alt="" style={{
        display: 'none'
      }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-2" data-mp="23u9uspw79hyc" />
      </noscript>
      <Hero data-id="element-3" data-mp="3ml12v6jcxkhy" />
      <main data-id="element-4" data-mp="3mkhlps1j704z">
        <PainPoints data-id="element-5" data-mp="3mk85gw6ag7ch" />
        <SolutionSection data-id="element-6" data-mp="3mjpyb4i388ps" />
        <HowItWorks data-id="element-7" data-mp="3rc9ca2kot5v4" />
        <MainProduct data-id="element-8" data-mp="3rbrcwx2qabiz" />
        <Bonuses data-id="element-9" data-mp="3rdkie91luppe" />
        <Collection data-id="element-10" data-mp="3rd1a7k1rbfok" />
        <GrowthMessage data-id="element-11" data-mp="3relw6la09qat" />
        <OfferStack data-id="element-12" data-mp="6hrlipoilfp" />
        <Faq data-id="element-13" data-mp="4wx1t3d72hu" />
        <FinalCta data-id="element-14" data-mp="5gel8p3rovc" />
      </main>
      <Footer data-id="element-15" data-mp="7ssnarqpf34" />
      <StickyCta data-id="element-16" data-mp="2zld0z6e9z99y" />
    </div>;
}